/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadsBulkRequestDocumentsInner } from './CreateLeadsBulkRequestDocumentsInner';
import {
    CreateLeadsBulkRequestDocumentsInnerFromJSON,
    CreateLeadsBulkRequestDocumentsInnerFromJSONTyped,
    CreateLeadsBulkRequestDocumentsInnerToJSON,
} from './CreateLeadsBulkRequestDocumentsInner';

/**
 * 
 * @export
 * @interface CreateLeadsBulkRequest
 */
export interface CreateLeadsBulkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    dob?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    lead_received_date: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLeadsBulkRequest
     */
    facility_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    source_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadsBulkRequest
     */
    source_contact_id?: string | null;
    /**
     * 
     * @type {Array<CreateLeadsBulkRequestDocumentsInner>}
     * @memberof CreateLeadsBulkRequest
     */
    documents?: Array<CreateLeadsBulkRequestDocumentsInner>;
}

/**
 * Check if a given object implements the CreateLeadsBulkRequest interface.
 */
export function instanceOfCreateLeadsBulkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "lead_received_date" in value;
    isInstance = isInstance && "facility_ids" in value;
    isInstance = isInstance && "source_id" in value;

    return isInstance;
}

export function CreateLeadsBulkRequestFromJSON(json: any): CreateLeadsBulkRequest {
    return CreateLeadsBulkRequestFromJSONTyped(json, false);
}

export function CreateLeadsBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadsBulkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'lead_received_date': json['lead_received_date'],
        'facility_ids': json['facility_ids'],
        'source_id': json['source_id'],
        'source_contact_id': !exists(json, 'source_contact_id') ? undefined : json['source_contact_id'],
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(CreateLeadsBulkRequestDocumentsInnerFromJSON)),
    };
}

export function CreateLeadsBulkRequestToJSON(value?: CreateLeadsBulkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'gender': value.gender,
        'lead_received_date': value.lead_received_date,
        'facility_ids': value.facility_ids,
        'source_id': value.source_id,
        'source_contact_id': value.source_contact_id,
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(CreateLeadsBulkRequestDocumentsInnerToJSON)),
    };
}

